import { html, LitElement } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import AabIcon from '@aab/sc-aab-icon/src/AabIcon';
import { sy_arrow_chevron_down as chevronDown } from '@aab/sc-aab-icon-set';
import Styles from './styles.scss';

export default class AabAccordion extends ScopedElementsMixin(LitElement) {
  constructor() {
    super();
    this.opened = false;
  }

  static get properties() {
    return {
      opened: { type: Boolean, reflect: true },
    };
  }

  static get styles() {
    return [Styles];
  }

  static get scopedElements() {
    return {
      'aab-icon': AabIcon,
    };
  }

  firstUpdated() {
    this.animationInProgress = false;
    const accordionContent = this.shadowRoot.querySelector('.accordion-content');
    if (this.opened) {
      accordionContent.style.overflow = 'visible';
    } else {
      accordionContent.classList.add('collapsed');
    }
  }

  toggleHeader(event) {
    event.preventDefault();
    this.opened = !this.opened;
    this.dispatchEvent(new CustomEvent('aab-toggle-accordion', {
      bubbles: true,
      composed: true,
      detail: { opened: this.opened },
    }));
  }

  setOpened(value) {
    this.animationInProgress = false;
    this.opened = value;
  }

  updated(changedProperties) {
    if (changedProperties.has('opened') && changedProperties.get('opened') !== undefined && !this.animationInProgress) {
      this.toggleAnimation(this.opened);
    }
  }

  toggleAnimation(opening) {
    this.animationInProgress = true;
    const accordionContent = this.shadowRoot.querySelector('.accordion-content');
    if (opening) {
      accordionContent.classList.remove('collapsed');
    }
    const { scrollHeight } = accordionContent;
    const eventListener = () => {
      accordionContent.removeEventListener('transitionend', eventListener);
      accordionContent.style.height = null;
      accordionContent.style.overflow = opening ? 'visible' : 'hidden';
    };
    accordionContent.addEventListener('transitionend', eventListener, false);
    requestAnimationFrame(() => {
      accordionContent.style.height = `${opening ? 0 : scrollHeight}px`;
      requestAnimationFrame(() => {
        accordionContent.style.height = `${opening ? scrollHeight : 0}px`;
        this.animationInProgress = false;
        if (!opening) {
          accordionContent.style.overflow = 'hidden';
          accordionContent.classList.add('collapsed');
        }
      });
    });
  }

  render() {
    return html`
      <div class="accordion">
        <a href="#" role="button" @click=${this.toggleHeader}>
          <div class="accordion-header d-flex justify-content-between">
            <slot name="header"></slot>
            <div class="d-flex pr-2 align-items-center">
              <slot name="${this.opened ? 'cta-collapse' : 'cta-expand'}"></slot>
              <span class="icon ${this.opened ? 'expand' : ''} icon-rotate">
                <aab-icon svg=${chevronDown} size="3"></aab-icon>
              </span>
            </div>
          </div>
        </a>
        <div class="accordion-content">
          <slot></slot>
        </div>
      </div>
    `;
  }
}
